import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import apiService from "../../../services/service";
import API_ROUTES from "../../../api-routes";
import { setGeneralTempForm } from "./tempFormDataSlice";

const useGeneralInformation = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const formRef = useRef(null);
  const generalInformation = useSelector(
    (state) => state.generalInformation.generalInformation,
  );

  const [isEditing, setIsEditing] = useState(false);
  const initialInformation = generalInformation?.data || {};
  const [tempFormData, setTempFormData] = useState(initialInformation);
  const [successMessage, setSuccessMessage] = useState("");
  const [skipReset, setSkipReset] = useState(false);
  const [resData, setResData] = useState(initialInformation);

  const updateFormDetails = (data) => {
    setTempFormData(data);
    apiService(API_ROUTES.UPDATE_ENTITY, "PUT", {
      replace: { id },
      body: JSON.stringify(data),
    });
  };

  const handleEditClick = () => {
    setIsEditing(true);
    setSuccessMessage("");
  };

  const handleSaveClick = async () => {
    setIsEditing(false);
    formRef.current.submit();
    setSuccessMessage("General Information has been Updated.");
  };

  useEffect(() => {
    if (tempFormData) {
      dispatch(setGeneralTempForm(tempFormData));
    }
  }, [tempFormData, dispatch]);

  return {
    isEditing,
    setIsEditing,
    tempFormData,
    setTempFormData,
    successMessage,
    setSuccessMessage,
    handleEditClick,
    handleSaveClick,
    updateFormDetails,
    formRef,
    skipReset,
    setSkipReset,
    resData,
    setResData,
  };
};

export default useGeneralInformation;
